'use client';

import { SvgVisible } from '@common/icon';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import CountUp from 'react-countup';

import { AuthQueryOptions, UnauthQueryOptions } from '@/api';
import { useAuthStore } from '@/stores/AuthStore';

interface ViewCountProps {
  id: number;
}

export const ViewCount = ({ id }: ViewCountProps) => {
  const isLogin = useAuthStore((state) => state.isLogin);
  const { data } = useQuery({
    ...(isLogin
      ? AuthQueryOptions['get:/wello/v2/auth/policy/feedback/{policyId}']
      : UnauthQueryOptions['get:/wello/v2/allows/policy/feedback/{policyId}'])(
      {
        path: {
          policyId: id,
        },
      },
    ),
    enabled: isLogin !== undefined,
    placeholderData: keepPreviousData,
    select: ({ context }) => ({
      readingCount: context?.readingCount ?? 0,
      hasNewComment: context?.newCommentYN ?? false,
      isThumbUp: context?.likeYN ?? false,
      thumbUpCount: context?.likeCount ?? 0,
      isBookmarked: context?.wishlistYN,
      bookmarkCount: context?.wishlistCount ?? 0,
      commentCount: context?.commentCount ?? 0,
      likeCount: context?.likeCount ?? 0,
    }),
  });

  const readingCount = data?.readingCount ?? 0;

  return (
    <small className="flex items-center font-600 text-Gray-600 typo-caption1">
      <SvgVisible className="mr-4 size-12" />
      <CountUp preserveValue duration={1} end={readingCount} />
      명이 보는 중
    </small>
  );
};
